<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PropertyTenantedListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PropertyTenantedListing from "@/views/pages/admin/propertyTenanted/propertyTenantedListing";

export default {
    page: {
        title: i18n.t("label.tenanted"),
    },
    components: { Layout, PageHeader, PropertyTenantedListing },
    data() {
        return {
            title: i18n.t("label.tenanted"),
            items: [
                {
                    text: i18n.t("module.property"),
                    href: '/properties',
                },
                {
                    text: i18n.t("label.tenanted"),
                    active: true,
                },
            ],
        };
    },
}
</script>
